/* PDPs „Dezent“ (Oktober 2026) – Bike-PDP (Entwurf 3 „Schritt für Schritt“, sections/sushi-dzp-main.liquid, [data-dzp]),
   B-Ware-PDP (gleicher Aufbau, sections/sushi-dzb-main.liquid, [data-dzb]) und Bundle-PDP (Entwurf 3 „Bundle-Wahl“ ohne Schritte,
   sections/sushi-dzbd-main.liquid, [data-dzbd]). Gemeinsam: Galerie, Preise, Warenkorb (/cart/add.js),
   Benachrichtigung (Klaviyo Back-in-Stock wie sushi-pdp.js), Größenberatung (#sg), Versandkosten (#vk) und die Reiter von
   „Dezent Details“. Hotspots und Kaufleiste (Handy) übernimmt sushi-dezent.js. */
(function () {
  if (window.__sushiDzp) return;  /* mehrere Sections binden die Datei ein – nur einmal ausführen */
  window.__sushiDzp = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const eur = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Bot-Schutz der Anmeldeformulare (31.10.2026): unsichtbares Feld „website“, das nur Bots ausfüllen, und mindestens 2 s zwischen
     Laden der Seite und Absenden. Trifft eins zu, zeigt das Formular „Danke“, schickt aber nichts an Klaviyo. */
  const HP_T0 = Date.now();
  const hpAdd = (f) => { if (f && !f.querySelector('.sushi-hp')) f.insertAdjacentHTML('beforeend', '<input class="sushi-hp" type="text" name="website" value="" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);opacity:0;pointer-events:none">'); };
  const hpBot = (f) => { const h = f.querySelector('.sushi-hp'); return !!(h && h.value) || Date.now() - HP_T0 < 2000; };
  const uniq = (a) => [...new Set(a)];

  /* Spanne der Einheitsgröße aus der Section-Einstellung (data-one-range, z. B. „155 - 185 cm“) statt aus dem Variantennamen */
  let ONE_RANGE = '';
  const oneFix = (v) => (ONE_RANGE && /^Einheit/i.test(v || '') ? String(v).replace(/\([^)]*\)/, '(' + ONE_RANGE + ')') : v);

  /* Größe aus dem Optionswert: „S (< 172 cm)“ → [0, 172] und ['S', 'bis 172 cm']; „Einheitsgröße (160 - 180 cm)“ → ['Eine Größe', '160–180 cm'] */
  function range(value) {
    value = oneFix(value);
    const m = /\(([^)]*)\)/.exec(value || '');
    if (!m) return null;
    const s = m[1], n = (s.match(/\d+/g) || []).map(Number);
    if (/</.test(s) && n[0]) return [0, n[0]];
    if (/>/.test(s) && n[0]) return [n[0], 999];
    return n.length >= 2 ? [n[0], n[1]] : null;
  }
  function sizeLabel(value) {
    value = oneFix(value);
    const name = value.split(' (')[0], m = /\(([^)]*)\)/.exec(value);
    const sub = m ? m[1].replace('< ', 'bis ').replace('> ', 'ab ').replace(/\s*-\s*/, '–') : '';
    return [/^Einheit/i.test(name) ? 'Eine Größe' : name, sub];
  }
  const short = (m) => m.replace(/\s*\d.*$/, '');

  function tabs() {
    document.addEventListener('click', (e) => {
      const t = e.target.closest('.pdt-nav [role=tab]');
      if (!t) return;
      $$('[role=tab]', t.parentElement).forEach((b) => {
        const on = b === t;
        b.setAttribute('aria-selected', on);
        b.tabIndex = on ? 0 : -1;
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    });
  }

  /* Technik-Gruppen in „Dezent Details“ (29.10.2026): am Handy beim Laden zu und aufklappbar, am Desktop immer offen */
  const GRP_MQ = matchMedia('(max-width: 749px)');
  const groupsSet = () => $$('.pdt-grp').forEach((d) => { d.open = !GRP_MQ.matches; });
  function specGroups() {
    document.addEventListener('click', (e) => {
      if (!GRP_MQ.matches && e.target.closest('.pdt-grp > summary')) e.preventDefault();
    });
    if (GRP_MQ.addEventListener) GRP_MQ.addEventListener('change', groupsSet); else GRP_MQ.addListener(groupsSet);
  }

  /* Vergleich „B-Ware oder neu?“ / „TABI oder 3.0+?“ (sections/sushi-dzb-compare, 29.10.2026): am Handy bleibt die Namen-Zeile per CSS
     sticky stehen – knapp unter dem Theme-Header, der beim Hochscrollen einfährt (--bw-top = Unterkante des Headers) */
  let cmpOn = false;
  function compareTop() {
    if (cmpOn || !$('[data-bw-cmp]')) return;
    cmpOn = true;
    const hdr = document.querySelector('.section-header');
    let raf = 0, tm = 0;
    const place = () => {
      raf = 0;
      const top = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
      $$('[data-bw-cmp]').forEach((el) => el.style.setProperty('--bw-top', top + 'px'));
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(place); clearTimeout(tm); tm = setTimeout(place, 260); };
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue);
    if (hdr) {  /* der Header blendet sich per Klasse und Übergang ein/aus – danach neu messen */
      if ('MutationObserver' in window) new MutationObserver(queue).observe(hdr, { attributes: true, attributeFilter: ['class', 'style'] });
      hdr.addEventListener('transitionend', queue);
    }
    place();
  }

  /* ------------------------------------------------------------------ gemeinsam */

  /* Galerie: list = [{u: Bild-URL mit width=1200, a: Alt-Text}] */
  function gallery(el, list) {
    const g = $('[data-gallery]', el), main = g && $('[data-gallery-main]', g), th = g && $('[data-gallery-thumbs]', g);
    if (!list.length || !main) return;
    const show = (m) => { main.src = m.u; main.srcset = [600, 900, 1200].map((w) => m.u.replace('width=1200', 'width=' + w) + ' ' + w + 'w').join(', '); main.alt = m.a || ''; };
    show(list[0]);
    th.innerHTML = list.map((m, i) => `<button type="button" class="${i ? '' : 'on'}" data-i="${i}" aria-label="Bild ${i + 1}"><img src="${esc(m.u.replace('width=1200', 'width=160'))}" alt="" loading="lazy" width="80" height="80"></button>`).join('');
    th.scrollLeft = 0;
    th.onclick = (e) => { const b = e.target.closest('button'); if (!b) return; show(list[+b.dataset.i]); $$('button', th).forEach((x) => x.classList.toggle('on', x === b)); };
  }

  /* Warenkorb: Positionen per /cart/add.js, danach Cart-Drawer bzw. -Notification des Themes (wie sushi-pdp.js) */
  async function addToCart(items, btn, done, T, variantId) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.disabled = true;
    done.hidden = true;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const res = await r.json();
      if (!r.ok || res.status) throw res;
      const first = res.items && res.items[0];
      if (first) { res.key = first.key; res.id = first.variant_id; }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sushi-dezent-pdp', productVariantId: variantId, cartData: res });
      if (cart && cart.renderContents && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); } else location.href = root + 'cart';
    } catch (err) {
      done.textContent = (err && err.description) || T.cartError;
      done.hidden = false;
    } finally { btn.disabled = false; }
  }

  /* Benachrichtigen: erster Klick zeigt das Feld, zweiter meldet an (Klaviyo, wie snippets/sushi-klaviyo-backinstock) */
  function notifyForm(f, done, T, variantId) {
    hpAdd(f);
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const inp = $('input', f);
      if (inp.hidden) { inp.hidden = false; inp.required = true; inp.focus(); return; }
      if (!inp.checkValidity()) { inp.reportValidity(); return; }
      if (hpBot(f)) { f.hidden = true; done.textContent = T.notifyOk; done.hidden = false; return; }
      const payload = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: inp.value } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId() } } } } };
      try {
        const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Xz24E7', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-10-15' }, body: JSON.stringify(payload) });
        if (!r.ok) throw new Error(r.status);
        f.hidden = true;
        done.textContent = T.notifyOk;
      } catch (err) { done.textContent = T.notifyError; }
      done.hidden = false;
    });
  }

  /* Größenberatung (#sg). A = { models: [Modell, …] (Reihenfolge der Buttons), sizesOf(m) → Größen-Optionswerte,
     colorsAvail(m, s) → lieferbare Farben, apply(m, s, h) → Auswahl übernehmen, ride (URL Probefahrt), altInseam (Schrittlänge,
     ab der bei S auch M passt; 0 = aus), out (Text „nicht lieferbar“), applyLabel(one, kurzname, größe) → Text der Übernehmen-Buttons
     (optional) }. Ein Modell mit einer Größe = Tiefeinsteiger, mit mehreren = Diamantrahmen. */
  function sizeGuide(dlg, A) {
    const SG = { model: A.models[0] };
    const label = (one, nm, big) => (A.applyLabel ? A.applyLabel(one, nm, big) : one ? nm + ' übernehmen' : 'Größe ' + big + ' übernehmen');
    const ONE = A.models.find((m) => A.sizesOf(m).length === 1), MANY = A.models.find((m) => A.sizesOf(m).length > 1);
    const KEY = (letter) => A.sizesOf(MANY || '').find((s) => sizeLabel(s)[0] === letter);
    function scale(box, min, max, segs, act) {
      box.innerHTML = segs.map((s) => `<span class="${s.k === act ? 'on' : ''}" style="left:${(s.a - min) / (max - min) * 100}%;width:${(s.b - s.a) / (max - min) * 100}%"><em>${esc(s.l)}</em></span>`).join('');
    }
    function stockLine(m, s, prefix) {
      const cs = uniq(A.colorsAvail(m, s));
      return cs.length ? `<p class="sg__stock"><i class="ok"></i>${prefix}Lieferbar in ${esc(cs.join(', '))}</p>` : `<p class="sg__stock"><i></i>${prefix}${esc(A.out)}</p>`;
    }
    function calc() {
      const h = +$('[data-sg-h]', dlg).value, use = $('[data-sg-use]', dlg).checked, iIn = $('[data-sg-i]', dlg), i = +iIn.value;
      iIn.disabled = !use;
      $('[data-sg-ifield]', dlg).classList.toggle('off', !use);
      $('[data-sg-hout]', dlg).textContent = h + ' cm';
      $('[data-sg-iout]', dlg).textContent = use ? i + ' cm' : '–';
      $$('[data-sg-model]', dlg).forEach((b) => b.setAttribute('aria-pressed', b.dataset.sgModel === SG.model));
      const one = SG.model === ONE;
      let big, title, text, alt = '', key, mode = '', sub = '';
      if (one) {
        key = A.sizesOf(ONE)[0];
        const rr = range(key) || [160, 180], nm = short(ONE);
        if (h >= rr[0] && h <= rr[1]) { mode = 'ok'; big = '✓'; sub = 'Eine Größe'; title = `Das ${nm} passt.`; text = `Eine Größe für ${rr[0]} bis ${rr[1]} cm. Durch den tiefen Einstieg spielt die Schrittlänge kaum eine Rolle.`; }
        else if (h > rr[1] && MANY) {
          mode = 'swap'; big = 'L'; sub = MANY; title = `Nimm lieber das ${MANY}.`;
          text = `Das ${esc(nm)} ist für ${rr[0]} bis ${rr[1]} cm gebaut. Mit ${h} cm sitzt du auf dem <b>${esc(MANY)} in Größe L</b> entspannter: Der Diamantrahmen ist größer und gibt deinen Beinen mehr Platz.`;
        } else if (h > rr[1]) { mode = 'probe'; big = '?'; title = `Über ${rr[1]} cm wird es knapp.`; text = `Das ${esc(nm)} ist bis ${rr[1]} cm gebaut. Ob es trotzdem passt, merkst du am besten bei einer kostenlosen Probefahrt.`; }
        else { mode = 'probe'; big = '?'; title = `Unter ${rr[0]} cm wird es knapp.`; text = `Das ${esc(nm)} ist ab ${rr[0]} cm gebaut. Ob es trotzdem passt, merkst du am besten bei einer kostenlosen Probefahrt.`; }
        scale($('[data-sg-hscale]', dlg), 150, 200, [{ a: 150, b: rr[0], l: '', k: 'lo' }, { a: rr[0], b: rr[1], l: nm, k: 'C' }, { a: rr[1], b: 200, l: MANY ? 'besser: ' + short(MANY) + ' L' : '', k: 'hi' }], h < rr[0] ? 'lo' : h <= rr[1] ? 'C' : 'hi');
        scale($('[data-sg-iscale]', dlg), 65, 95, [{ a: 65, b: 95, l: 'beim Tiefeinsteiger unkritisch', k: 'z' }], '');
      } else {
        /* Körpergröße S ≤ 172 · M 173–179 · L ab 180 cm; Schrittlänge S ≤ 76 · M 77–79 · L ab 80 cm (Seiten „Rahmengrößen“ 3.0 und 3.0+) */
        const hs = h <= 172 ? 'S' : h <= 179 ? 'M' : 'L', is = i <= 76 ? 'S' : i <= 79 ? 'M' : 'L', o = 'SML';
        let rec = hs;
        if (use && o.indexOf(is) < o.indexOf(hs)) { rec = is; text = `Nach Körpergröße wäre es ${hs}, nach Schrittlänge ${is}. Für sicheres Absteigen empfehlen wir <b>${is}</b>.`; }
        else if (use && hs === 'S' && A.altInseam && i >= A.altInseam) { alt = 'M'; text = `Nach Körpergröße <b>S</b>. Mit ${i} cm Schrittlänge passt auch <b>M</b> sehr gut – der Abstand zum Lenker bleibt fast gleich.`; }
        else if (use && o.indexOf(is) > o.indexOf(hs)) { alt = is; text = `Nach Körpergröße <b>${hs}</b>. Mit ${i} cm Schrittlänge sitzt du auch auf ${is} gut.`; }
        else text = `Für ${h} cm${use ? ' und ' + i + ' cm Schrittlänge' : ''} ist <b>Größe ${rec}</b> richtig.`;
        key = KEY(rec); big = rec; title = `Rahmengröße ${rec}`;
        scale($('[data-sg-hscale]', dlg), 150, 200, [{ a: 150, b: 172.5, l: 'S', k: 'S' }, { a: 172.5, b: 179.5, l: 'M', k: 'M' }, { a: 179.5, b: 200, l: 'L', k: 'L' }], hs);
        scale($('[data-sg-iscale]', dlg), 65, 95, [{ a: 65, b: 76.5, l: 'S', k: 'S' }, { a: 76.5, b: 79.5, l: 'M', k: 'M' }, { a: 79.5, b: 95, l: 'L', k: 'L' }], use ? is : '');
      }
      const stock = mode === 'swap' ? stockLine(MANY, KEY('L'), esc(MANY) + ' in L: ') : stockLine(SG.model, key, '');
      const altAv = alt && A.colorsAvail(SG.model, KEY(alt)).length > 0;
      const nm = short(SG.model);
      $('[data-sg-result]', dlg).innerHTML = `<p class="dz-eye">Unsere Empfehlung</p><p class="sg__big">${esc(big)}${sub ? '<small>' + esc(sub) + '</small>' : ''}</p><h3>${esc(title)}</h3><p>${text}</p>${stock}` +
        (altAv ? `<p class="sg__alt">Alternative: Größe ${alt} ist sofort lieferbar.</p>` : '') +
        (mode === 'swap' ? `<button type="button" class="dz-btn" data-sg-switch="${esc(MANY)}">Zum ${esc(MANY)} wechseln</button><button type="button" class="dz-btn dz-btn--ghost sg__alt-btn" data-sg-apply data-key="${esc(key)}">Trotzdem ${esc(nm)}</button>`
          : mode === 'probe' ? `<button type="button" class="dz-btn" data-sg-apply data-key="${esc(key)}">${esc(label(true, nm, ''))}</button>` + (A.ride ? `<a class="dz-btn dz-btn--ghost sg__alt-btn" href="${esc(A.ride)}">Probefahrt buchen</a>` : '')
          : `<button type="button" class="dz-btn" data-sg-apply data-key="${esc(key)}">${esc(label(one, nm, big))}</button>` +
            (altAv ? `<button type="button" class="dz-btn dz-btn--ghost sg__alt-btn" data-sg-apply data-key="${esc(KEY(alt))}">${esc(label(false, nm, alt))}</button>` : ''));
    }
    dlg.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-sg-close]') || t === dlg) { dlg.close(); return; }
      const sm = t.closest('[data-sg-model]'); if (sm) { SG.model = sm.dataset.sgModel; calc(); return; }
      const sw = t.closest('[data-sg-switch]'); if (sw) { SG.model = sw.dataset.sgSwitch; calc(); return; }
      if (t.closest('[data-sg-how]')) { e.preventDefault(); $('#sg-messen', dlg).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      const a = t.closest('[data-sg-apply]'); if (a) { A.apply(SG.model, a.dataset.key, +$('[data-sg-h]', dlg).value); dlg.close(); }
    });
    dlg.addEventListener('input', calc);
    dlg.addEventListener('change', calc);
    return { open(model, h) { SG.model = A.models.includes(model) ? model : A.models[0]; if (h) $('[data-sg-h]', dlg).value = h; calc(); dlg.showModal(); } };
  }

  /* Versandkosten (#vk). lands = [{name, bike, more, acc, carrier}], text() → Satz „Für deine Auswahl“ */
  function shipping(vk, lands, rest, text) {
    let L = 0;
    function calc() {
      const c = lands[L] || lands[0];
      $$('[data-vk-land]', vk).forEach((b) => b.setAttribute('aria-pressed', +b.dataset.vkLand === L));
      $$('[data-vk]', vk).forEach((d) => (d.textContent = c[d.dataset.vk] || ''));
      $('[data-vk-big]', vk).textContent = c.bike;
      $('[data-vk-title]', vk).textContent = 'Versand nach ' + c.name;
      $('[data-vk-text]', vk).textContent = text();
      $('[data-vk-carrier]', vk).textContent = `Versandpartner: Bike ${c.carrier}` + (rest ? ' · ' + rest : '');
    }
    vk.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-vk-close]') || t === vk) { vk.close(); return; }
      const l = t.closest('[data-vk-land]'); if (l) { L = +l.dataset.vkLand; calc(); }
    });
    return { open() { calc(); vk.showModal(); } };
  }

  /* Schritte der Kaufkarte; names = Schrittnamen, last = Text des Buttons vor der Übersicht */
  function steps(el, names, T) {
    let STEP = 0;
    const max = names.length - 1;
    function show(i, scroll) {
      STEP = Math.max(0, Math.min(max, i));
      $$('[data-step]', el).forEach((s) => s.classList.toggle('on', +s.dataset.step === STEP));
      $$('.p3-prog [data-goto]', el).forEach((b) => { const n = +b.dataset.goto; b.classList.toggle('on', n === STEP); b.classList.toggle('done', n < STEP); b.setAttribute('aria-current', n === STEP ? 'step' : 'false'); });
      $('[data-back]', el).hidden = STEP === 0;
      const nx = $('[data-next]', el);
      nx.hidden = STEP === max;
      nx.textContent = STEP === max - 1 ? T.toSummary : T.next + ': ' + names[STEP + 1];
      if (scroll) { const c = $('.p3-card', el), top = c.getBoundingClientRect().top; if (top < 0 || top > innerHeight * 0.6) c.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    return { show, get: () => STEP, max };
  }

  /* Card beginnt bündig mit dem Bild: Höhe des Titels links */
  function headHeight(el) {
    const head = $('.p3-head', el), grid = $('.p3-grid', el);
    if (!head || !grid) return;
    const set = () => grid.style.setProperty('--p3-head', head.offsetHeight + 'px');
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(head);
    set();
  }

  /* Klicks außerhalb der Section (z. B. „Dezent Details“): nur der Button zur Größenberatung öffnet das Pop-up */
  function outside(el, open) {
    document.addEventListener('click', (e) => {
      if (!el.isConnected || el.contains(e.target)) return;  /* im Theme-Editor neu geladene Section */
      if (e.target.closest('[data-sg-open]')) open();
    });
  }

  /* ------------------------------------------------------------------ Bike-PDP */
  function init(el) {
    const json = $('[data-dzp-json]', el);
    if (!json || el.dataset.ready) return;
    el.dataset.ready = '1';
    const D = JSON.parse(json.textContent), T = D.texts, low = +el.dataset.low || 10;
    D.extras = $$('[data-extra]', el).map((b) => ({ id: +b.dataset.extra, p: +b.dataset.price, t: b.dataset.title }));
    const idIn = $('[data-id]', el), dnote = $('[data-dnote]', el), form = $('.pd-form', el), done = $('[data-done]', el);
    const v0 = D.variants.find((v) => v.id === +idIn.value) || D.variants[0];
    const S = { model: v0.o[0], size: v0.o[1], color: v0.o[2], extras: new Set() };
    const vOf = (m) => D.variants.filter((v) => v.o[0] === m);
    const find = (m, s, c) => D.variants.find((v) => v.o[0] === m && v.o[1] === s && v.o[2] === c);
    const sizesOf = (m) => uniq(vOf(m).map((v) => v.o[1]));
    const colorsOf = (m) => Object.keys(D.colors).filter((c) => vOf(m).some((v) => v.o[2] === c));
    const models = uniq(D.variants.map((v) => v.o[0]));
    const ONE = models.find((m) => sizesOf(m).length === 1), MANY = models.find((m) => sizesOf(m).length > 1);
    const cur = () => find(S.model, S.size, S.color);
    const lowQ = (v) => v.q != null && v.q > 0 && v.q <= low;

    function defaults(m) { const v = vOf(m).find((x) => x.av) || vOf(m)[0]; S.size = v.o[1]; S.color = v.o[2]; }
    function setModel(m) { if (S.model === m) return; S.model = m; defaults(m); render(); }
    function setSize(s) { S.size = s; const v = cur(); if (!v || !v.av) { const a = vOf(S.model).find((x) => x.o[1] === s && x.av); if (a) S.color = a.o[2]; } render(); }
    function setColor(c) { S.color = c; const v = cur(); if (!v || !v.av) { const a = vOf(S.model).find((x) => x.o[2] === c && x.av); if (a) S.size = a.o[1]; } render(); }
    function sizeFor(h) { return sizesOf(S.model).find((x) => { const r = range(x); return r && h >= r[0] && h <= r[1]; }); }

    /* Galerie: Bilder „<Modell> <Farbe> …“, Größenbilder („… in Größe S: …“) nur zur gewählten Größe */
    function pics() {
      const prefix = S.model + ' ' + S.color, letter = sizeLabel(S.size)[0];
      return D.media.filter((m) => (m.a || '').indexOf(prefix) === 0 && (!/in Größe (S|M|L)\b/.test(m.a) || m.a.includes('Größe ' + letter + ':')));
    }

    const set = (k, h) => $$('[data-out="' + k + '"]', el).forEach((e) => (e.innerHTML = h));
    let lastV = null;
    function render() {
      const v = cur();
      if (!v) return;
      $$('[data-model]', el).forEach((b) => b.setAttribute('aria-pressed', b.dataset.model === S.model));
      $$('[data-sizes]', el).forEach((box) => {
        box.innerHTML = sizesOf(S.model).map((s) => {
          const l = sizeLabel(s), av = vOf(S.model).some((x) => x.o[1] === s && x.av);
          return `<button type="button" class="pd-size${av ? '' : ' out'}" data-size="${esc(s)}" aria-pressed="${s === S.size}"><b>${esc(l[0])}</b><small>${esc(l[1])}${av ? '' : ' · ausverkauft'}</small></button>`;
        }).join('');
      });
      $$('[data-colors]', el).forEach((box) => {
        box.innerHTML = colorsOf(S.model).map((c) => {
          const x = find(S.model, S.size, c), av = x && x.av;
          return `<button type="button" class="pd-color${av ? '' : ' out'}" data-color="${esc(c)}" aria-pressed="${c === S.color}"><i style="background:${esc(D.colors[c])}"></i><b>${esc(c)}</b><small>${av ? (lowQ(x) ? 'nur noch ' + x.q : 'lieferbar') : 'ausverkauft'}</small></button>`;
        }).join('');
      });
      const ex = D.extras.filter((e) => S.extras.has(e.id)), exSum = ex.reduce((a, e) => a + e.p, 0);
      $$('[data-extra]', el).forEach((b) => b.setAttribute('aria-pressed', S.extras.has(+b.dataset.extra)));
      const total = v.p + exSum, cmp = (v.c > v.p ? v.c : v.p) + exSum, save = v.c - v.p;
      set('price', eur(total));
      set('compare', cmp > total ? eur(cmp) : '');
      set('save', save > 0 ? esc(T.save.replace('[betrag]', eur(save))) : '');
      if (T.rate) set('rate', esc(T.rate.replace('[betrag]', eur(Math.floor(total / 12)))) + '<a class="dz-fn" href="#fussnoten" aria-label="Fußnote: Pflichtangaben zur Ratenzahlung">*</a>');
      let stock;
      if (v.av) {
        let t = v.d && !/^sofort versandbereit/i.test(v.d) ? v.d : T.ready;
        if (lowQ(v)) t = T.lowStock.replace('[anzahl]', v.q) + ' · ' + t;
        stock = `<i class="${v.ds === 'yellow' ? 'low' : 'ok'}"></i>${esc(t)}`;
      } else stock = `<i></i>${esc(T.soldout)}`;
      set('stock', stock);
      set('barlabel', esc(S.model + ' · ' + S.color));
      set('barprice', eur(total) + (cmp > total ? ' <s>' + eur(cmp) + '</s>' : ''));
      $$('[data-cta]', el).forEach((b) => (b.hidden = !v.av));
      $$('[data-out="rate"]', el).forEach((e) => (e.hidden = !v.av));
      if (lastV !== v.id) {
        lastV = v.id;
        $$('[data-notify]', el).forEach((f) => { const i = $('input', f); i.hidden = true; i.required = false; i.value = ''; });
        $$('[data-done]', el).forEach((d) => (d.hidden = true));
        idIn.value = v.id;
        const note = v.ov || v.dd ? 'Voraussichtliche Lieferung: ' + (v.ov || v.dd) : '';
        dnote.value = note;
        dnote.disabled = !note;
        if (location.search.includes('variant=') || v.id !== v0.id) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      }
      $$('[data-notify]', el).forEach((f) => (f.hidden = v.av));
      $$('[data-bundle-hint]', el).forEach((h) => (h.hidden = !!h.dataset.bundleHint && h.dataset.bundleHint !== S.model));
      review(ex);
      gallery(el, pics());
      fit();
    }

    /* Übersicht: Auswahl mit „ändern“ */
    function review(ex) {
      const r = $('[data-review]', el);
      if (!r) return;
      const row = (k, val, go) => `<li><span>${esc(k)}</span><b>${esc(val)}<button type="button" data-goto="${go}">${esc(T.change)}</button></b></li>`;
      const l = sizeLabel(S.size);
      r.innerHTML = row(T.steps[0], S.model, 0) + row(T.steps[1], l.filter(Boolean).join(' · '), 1) + row(T.steps[2], S.color, 2) +
        row(T.steps[3], ex.length ? ex.map((e) => e.t.replace('SUSHI BIKES ', '')).join(', ') : T.noExtras, 3);
    }

    /* Körpergröße → Empfehlung im Schritt „Größe“ */
    function fit() {
      const r = $('[data-height]', el);
      if (!r) return;
      const h = +r.value, s = sizeFor(h);
      $$('[data-out="height"]', el).forEach((e) => (e.textContent = h + ' cm'));
      let t;
      if (S.model === ONE) {
        const rr = range(S.size) || [0, 999];
        t = s ? `<b>Passt!</b> Das ${esc(short(ONE))} ist für ${rr[0]} bis ${rr[1]} cm gebaut.`
          : h < rr[0] ? `Mit ${h} cm lohnt sich eine kurze <button type="button" class="dz-link" data-sg-open>Größenberatung</button>.`
          : MANY ? `Ab ${rr[1]} cm passt das ${esc(MANY)} in L besser.` : '';
      } else {
        t = s ? `Empfohlen: <b>Größe ${esc(sizeLabel(s)[0])}</b> (${esc(sizeLabel(s)[1])})` + (vOf(S.model).some((x) => x.o[1] === s && x.av) ? '' : ' · gerade ausverkauft')
          : `Unter 150 cm: bitte zur <button type="button" class="dz-link" data-sg-open>Größenberatung</button>.`;
      }
      $$('[data-out="fit"]', el).forEach((e) => (e.innerHTML = t));
    }

    const step = steps(el, T.steps, T);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = cur();
      if (!v || !v.av) return;
      const items = [{ id: v.id, quantity: 1, properties: dnote.disabled ? {} : { __delivery_note: dnote.value } }];
      S.extras.forEach((id) => items.push({ id, quantity: 1 }));
      addToCart(items, $('[data-cta]', el), done, T, v.id);
    });
    $$('[data-notify]', el).forEach((f) => notifyForm(f, done, T, () => cur().id));

    const dlg = $('#sg', el), vk = $('#vk', el), hr = $('[data-height]', el);
    const sg = dlg && sizeGuide(dlg, {
      models: $$('[data-sg-model]', dlg).map((b) => b.dataset.sgModel), sizesOf, ride: T.ride, altInseam: 78, out: 'Gerade ausverkauft',
      colorsAvail: (m, s) => D.variants.filter((v) => v.o[0] === m && v.o[1] === s && v.av).map((v) => v.o[2]),
      apply: (m, s, h) => { if (hr) hr.value = h; if (S.model !== m) { S.model = m; defaults(m); } setSize(s); },
    });
    const ship = vk && shipping(vk, D.vk, T.carrierRest, () => `Dein ${S.model} in ${S.color}` + (S.extras.size ? ' samt Zubehör – alles in einem Versandpreis.' : '. Bestellst du Zubehör dazu, ist es im Versandpreis schon drin.'));
    const openSg = () => sg && sg.open(S.model, hr && hr.value);
    outside(el, openSg);

    el.addEventListener('click', (e) => {
      const t = e.target;
      const m = t.closest('[data-model]'); if (m) { setModel(m.dataset.model); return; }
      const s = t.closest('[data-size]'); if (s) { setSize(s.dataset.size); return; }
      const c = t.closest('[data-color]'); if (c) { setColor(c.dataset.color); return; }
      const x = t.closest('[data-extra]'); if (x) { const id = +x.dataset.extra; S.extras.has(id) ? S.extras.delete(id) : S.extras.add(id); render(); return; }
      const g = t.closest('[data-goto]'); if (g) { step.show(+g.dataset.goto, g.closest('[data-review]')); return; }
      if (t.closest('[data-next]')) { step.show(step.get() + 1, true); return; }
      if (t.closest('[data-back]')) { step.show(step.get() - 1, true); return; }
      if (t.closest('[data-bar-cta]')) { e.preventDefault(); step.show(step.max); $('.p3-card', el).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (t.closest('[data-sg-open]')) { openSg(); return; }
      if (ship && t.closest('[data-vk-open]')) ship.open();
    });
    el.addEventListener('input', (e) => {
      if (e.target.matches('[data-height]')) { fit(); const s = sizeFor(+e.target.value); if (s && S.model !== ONE && s !== S.size) setSize(s); }
    });
    headHeight(el);
    /* Startgröße des Körpergrößen-Reglers passend zur Variante aus der URL */
    const r0 = range(S.size);
    if (hr && r0 && S.model !== ONE) hr.value = Math.round((Math.max(r0[0], +hr.min) + Math.min(r0[1], +hr.max)) / 2);
    /* Link mit fertiger Auswahl (?variant=…&uebersicht=1, z. B. Startseite): direkt in die Übersicht */
    const sp = new URLSearchParams(location.search), lv = D.variants.find((v) => v.id === +sp.get('variant'));
    step.show(D.startSummary && sp.has('uebersicht') && lv && lv.av ? step.max : 0);
    render();
  }

  /* ------------------------------------------------------------------ B-Ware-PDP (Zustand → Größe → Farbe → Übersicht)
     D.variants: [{id, s (Größe bzw. „Einheitsgröße (… cm)“), c (Farbe), k (A/B/C), p, cmp, av, img}], D.pair: anderes B-Ware-Modell
     für die Größenberatung (gleiche Felder + url), D.grades: {A: [Name, Text]}, D.sized: Produkt hat eine Größen-Option */
  function initBware(el) {
    const json = $('[data-dzb-json]', el);
    if (!json || el.dataset.ready) return;
    el.dataset.ready = '1';
    const D = JSON.parse(json.textContent), T = D.texts;
    const idIn = $('[data-id]', el), form = $('.pd-form', el), done = $('[data-done]', el), hr = $('[data-height]', el);
    const V = D.variants, v0 = V.find((v) => v.id === +idIn.value) || V.find((v) => v.av) || V[0];
    const ST = { s: v0.s, c: v0.c, k: v0.k };
    const vf = (s, c, k) => V.find((v) => v.s === s && v.c === c && v.k === k);
    const cur = () => vf(ST.s, ST.c, ST.k);
    const SIZES = uniq(V.map((v) => v.s)), COLS = Object.keys(D.colors).filter((c) => V.some((v) => v.c === c)), KS = Object.keys(D.grades).filter((k) => V.some((v) => v.k === k));
    const sizeFor = (h) => SIZES.find((x) => { const r = range(x); return r && h >= r[0] && h <= r[1]; });
    const cross = `<a href="${esc(T.crossUrl)}">${esc(T.crossLabel)}</a>`;

    /* Wert wählen; ist die Kombination nicht da, die nächste lieferbare mit diesem Wert nehmen */
    function pick(f, val) {
      ST[f] = val;
      const v = cur();
      if (!v || !v.av) {
        const a = V.filter((x) => x[f] === val && x.av);
        const b = a.find((x) => x.s === ST.s && x.c === ST.c) || a.find((x) => x.s === ST.s) || a.find((x) => x.c === ST.c) || a[0];
        if (b) { ST.s = b.s; ST.c = b.c; ST.k = b.k; }
        else if (!vf(ST.s, ST.c, ST.k)) { const any = V.find((x) => x[f] === val); if (any) { ST.s = any.s; ST.c = any.c; ST.k = any.k; } }
      }
      render();
    }

    const set = (k, h) => $$('[data-out="' + k + '"]', el).forEach((e) => (e.innerHTML = h));
    let lastV = null;
    function render() {
      const v = cur();
      if (!v) return;
      $$('[data-k]', el).forEach((b) => {
        const k = b.dataset.k, here = vf(ST.s, ST.c, k), x = here || V.find((y) => y.k === k), any = V.some((y) => y.k === k && y.av);
        b.setAttribute('aria-pressed', k === ST.k);
        b.classList.toggle('out', !any);
        $$('[data-gp]', b).forEach((e) => (e.textContent = eur(x.p)));
        $$('[data-gc]', b).forEach((e) => (e.textContent = x.cmp > x.p ? eur(x.cmp) : ''));
        $$('[data-gav]', b).forEach((e) => (e.textContent = here && here.av ? T.avail : any ? T.availOther : T.notHere));
      });
      set('gtext', `<b>${esc(ST.k)} – ${esc(D.grades[ST.k][0])}:</b> ${esc(D.grades[ST.k][1])} ${esc(T.gradeNote)}`);
      $$('[data-sizes]', el).forEach((box) => {
        box.innerHTML = SIZES.map((s) => {
          const l = sizeLabel(s), av = V.some((x) => x.s === s && x.av);
          return `<button type="button" class="pd-size${av ? '' : ' out'}" data-size="${esc(s)}" aria-pressed="${s === ST.s}"><b>${esc(l[0])}</b><small>${esc(l[1])}${av ? '' : ' · ' + esc(T.notThere)}</small></button>`;
        }).join('');
      });
      $$('[data-colors]', el).forEach((box) => {
        box.innerHTML = COLS.map((c) => {
          const x = vf(ST.s, c, ST.k), any = V.some((y) => y.s === ST.s && y.c === c && y.av);
          return `<button type="button" class="pd-color${x && x.av ? '' : ' out'}" data-color="${esc(c)}" aria-pressed="${c === ST.c}"><i style="background:${esc(D.colors[c])}"></i><b>${esc(c)}</b><small>${x && x.av ? T.avail : any ? T.otherGrade : T.notThere}</small></button>`;
        }).join('');
      });
      const save = v.cmp - v.p;
      set('price', eur(v.p));
      set('compare', v.cmp > v.p ? eur(v.cmp) : '');
      set('save', save > 0 ? esc(T.save.replace('[betrag]', eur(save))) : '');
      if (T.rate) set('rate', esc(T.rate.replace('[betrag]', eur(Math.floor(v.p / 12)))) + '<a class="dz-fn" href="#fussnoten" aria-label="Fußnote: Pflichtangaben zur Ratenzahlung">*</a>');
      set('stock', v.av ? `<i class="ok"></i>${esc(T.ready)}` : `<i></i>${esc(T.soldout)}`);
      const name = [D.model].concat(D.sized ? [sizeLabel(v.s)[0]] : [], [v.c, T.condWord + ' ' + v.k]).join(' · ');
      set('barlabel', esc('B-Ware ' + name));
      set('barprice', eur(v.p) + (v.cmp > v.p ? ' <s>' + eur(v.cmp) + '</s>' : ''));
      $$('[data-cta]', el).forEach((b) => (b.hidden = !v.av));
      $$('[data-out="rate"]', el).forEach((e) => (e.hidden = !v.av));
      if (lastV !== v.id) {
        lastV = v.id;
        $$('[data-notify]', el).forEach((f) => { const i = $('input', f); i.hidden = true; i.required = false; i.value = ''; });
        $$('[data-done]', el).forEach((d) => (d.hidden = true));
        idIn.value = v.id;
        if (location.search.includes('variant=') || v.id !== v0.id) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      }
      $$('[data-notify]', el).forEach((f) => (f.hidden = v.av));
      const r = $('[data-review]', el);
      if (r) {
        const row = (k, val, go) => `<li><span>${esc(k)}</span><b>${esc(val)}<button type="button" data-goto="${go}">${esc(T.change)}</button></b></li>`;
        r.innerHTML = row(T.steps[0], `${v.k} – ${D.grades[v.k][0]}`, 0) + (D.sized ? row(T.steps[1], sizeLabel(v.s).filter(Boolean).join(' · '), 1) : '') + row(T.steps[2], v.c, 2);
      }
      gallery(el, [{ u: v.img, a: v.alt }].concat(D.extra || []));
      fit();
    }

    /* Körpergröße → Empfehlung im Schritt „Größe“ bzw. „Passt es zu dir?“ */
    function fit() {
      if (!hr) return;
      const h = +hr.value, s = sizeFor(h);
      $$('[data-out="height"]', el).forEach((e) => (e.textContent = h + ' cm'));
      const guide = `<button type="button" class="dz-link" data-sg-open>${esc(T.guide)}</button>`;
      let t;
      if (!D.sized) {
        const rr = range(SIZES[0]) || [160, 180];
        t = s ? `<b>Passt zu dir:</b> Das ${esc(D.model)} ist für ${rr[0]}–${rr[1]} cm gemacht.`
          : `Das ${esc(D.model)} passt bei ${rr[0]}–${rr[1]} cm Körpergröße. Mehr in der ${guide}.`;
      } else if (!s) t = `<b>Für ${h} cm haben wir keine passende Rahmengröße.</b> Mehr in der ${guide}.`;
      else {
        const l = sizeLabel(s), cs = uniq(V.filter((x) => x.s === s && x.av).map((x) => x.c));
        t = `<b>Bei ${h} cm passt Größe ${esc(l[0])}.</b> ` + (cs.length ? `Gerade da in ${esc(cs.join(' und '))}.` : `In ${esc(l[0])} haben wir gerade keine B-Ware. ${cross} gibt es in drei Rahmengrößen.`);
      }
      $$('[data-out="fit"]', el).forEach((e) => (e.innerHTML = t));
    }

    const step = steps(el, T.steps, T);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = cur();
      if (!v || !v.av) return;
      addToCart([{ id: v.id, quantity: 1 }], $('[data-cta]', el), done, T, v.id);
    });
    $$('[data-notify]', el).forEach((f) => notifyForm(f, done, T, () => cur().id));

    /* Größenberatung mit beiden B-Ware-Modellen; Übernehmen beim anderen Modell führt zu dessen Seite */
    const P = D.pair, dlg = $('#sg', el), vk = $('#vk', el);
    const sizesOf = (m) => (m === D.model ? SIZES : P && m === P.model ? uniq(P.variants.map((v) => v.s)) : []);
    const sg = dlg && sizeGuide(dlg, {
      models: $$('[data-sg-model]', dlg).map((b) => b.dataset.sgModel), sizesOf, ride: T.ride, altInseam: D.altInseam || 0, out: 'Gerade keine B-Ware',
      colorsAvail: (m, s) => (m === D.model ? V : P && m === P.model ? P.variants : []).filter((v) => v.s === s && v.av).map((v) => v.c),
      apply: (m, s, h) => {
        if (m !== D.model) { const pv = P.variants.find((v) => v.s === s && v.av) || P.variants.find((v) => v.s === s); location.href = P.url + (pv ? '?variant=' + pv.id : ''); return; }
        if (hr) hr.value = h;
        pick('s', s);
      },
    });
    const ship = vk && shipping(vk, D.vk, T.carrierRest, () => `Für dein B-Ware ${D.model} in ${ST.c}. Bestellst du Zubehör dazu, ist es im Versandpreis schon drin.`);
    const openSg = () => sg && sg.open(D.model, hr && hr.value);
    outside(el, openSg);

    el.addEventListener('click', (e) => {
      const t = e.target;
      const k = t.closest('[data-k]'); if (k) { pick('k', k.dataset.k); return; }
      const s = t.closest('[data-size]'); if (s) { pick('s', s.dataset.size); return; }
      const c = t.closest('[data-color]'); if (c) { pick('c', c.dataset.color); return; }
      const g = t.closest('[data-goto]'); if (g) { step.show(+g.dataset.goto, g.closest('[data-review]')); return; }
      if (t.closest('[data-next]')) { step.show(step.get() + 1, true); return; }
      if (t.closest('[data-back]')) { step.show(step.get() - 1, true); return; }
      if (t.closest('[data-bar-cta]')) { e.preventDefault(); step.show(step.max); $('.p3-card', el).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (t.closest('[data-sg-open]')) { openSg(); return; }
      if (ship && t.closest('[data-vk-open]')) ship.open();
    });
    el.addEventListener('input', (e) => {
      if (!e.target.matches('[data-height]')) return;
      fit();
      const s = sizeFor(+e.target.value);
      if (D.sized && s && s !== ST.s && V.some((x) => x.s === s && x.av)) pick('s', s);
    });
    headHeight(el);
    const r0 = range(ST.s);
    if (hr && r0 && D.sized) hr.value = Math.round((Math.max(r0[0], +hr.min) + Math.min(r0[1], +hr.max)) / 2);
    /* Mit gewähltem, lieferbarem Bike (z. B. aus der B-Ware-Übersicht) direkt in die Übersicht */
    const linked = +new URLSearchParams(location.search).get('variant'), lv = V.find((v) => v.id === linked);
    step.show(D.startSummary && lv && lv.av ? step.max : 0);
    render();
  }

  /* ------------------------------------------------------------------ Bundle-PDP („Bundle-Wahl“, ohne Schritte)
     D.variants: [{id, c (Farbe), x (zweite Option oder ''), av, q, p, cmp, f (Variantenbild), g (weitere Bilder), calm, d …}],
     D.parts: Bestandteile [{name, sub, bullets, p, url, bike, vars: [{label, u}]}] – Zeilen und Kacheln mit [data-part="i"] auf der
     ganzen Seite (auch „Dezent Details“), D.bike: Bike-Produkt für die Größenberatung. Links mit [data-sw-url] (Umschalter,
     Bundle-Vergleich) führen zum anderen Bundle in derselben Farbe. */
  /* Bundle-PDP am Handy (29.10.2026): Kaufkarte mit drei Schritten wie die Bike-PDP. Umschalter, Bestandteile, Auswahl und
     Kaufblock wandern am Handy in die Schritte (Platzhalter merken die alte Stelle) und am Desktop zurück. */
  const BD_MQ = matchMedia('(max-width: 749px)');
  function bundleSteps(el) {
    const card = $('[data-bd-mcard]', el);
    if (!card) return;
    const slot = (n) => $('[data-slot="' + n + '"]', card);
    const back = $('[data-bback]', card), next = $('[data-bnext]', card), names = (card.dataset.names || '').split('|');
    const partsBlk = ($('.bd-parts', el) || {}).parentElement;
    const plan = [
      [$('.bd-switch', el), 'switch'], [partsBlk, 'parts'], [$('.bd-sumline', el), 'sum'], [$('.bd-saveline', el), 'sum'],
      [$('.bd-cfg', el), 'cfg'], [$('.bd-buy', el), 'buy']
    ];
    let moved = [], S = 0;
    const show = (i, scroll) => {
      S = Math.max(0, Math.min(2, i));
      $$('[data-bst]', card).forEach((s) => s.classList.toggle('on', +s.dataset.bst === S));
      $$('.bd-mprog [data-bgo]', card).forEach((b) => { const n = +b.dataset.bgo; b.classList.toggle('on', n === S); b.classList.toggle('done', n < S); b.setAttribute('aria-current', n === S ? 'step' : 'false'); });
      back.hidden = S === 0;
      next.hidden = S === 2;
      next.textContent = card.dataset.next + ': ' + (names[S + 1] || '');
      if (scroll) { const top = card.getBoundingClientRect().top; if (top < 0 || top > innerHeight * 0.6) scrollTo({ top: top + scrollY - 80, behavior: 'smooth' }); }
    };
    const apply = () => {
      if (BD_MQ.matches && !moved.length) {
        plan.forEach(([node, to]) => {
          if (!node) return;
          const ph = document.createComment('bd');
          node.before(ph);
          moved.push([node, ph]);
          slot(to).append(node);
        });
        card.hidden = false;
      } else if (!BD_MQ.matches && moved.length) {
        moved.reverse().forEach(([node, ph]) => ph.replaceWith(node));
        moved = [];
        card.hidden = true;
      }
    };
    card.addEventListener('click', (e) => {
      const g = e.target.closest('[data-bgo]');
      if (g) return show(+g.dataset.bgo, g.closest('[data-bd-review]'));
      if (e.target.closest('[data-bback]')) return show(S - 1, true);
      if (e.target.closest('[data-bnext]')) show(S + 1, true);
    });
    $$('[data-bar-cta]', el).forEach((a) => a.addEventListener('click', () => { if (BD_MQ.matches) show(2); }));
    if (BD_MQ.addEventListener) BD_MQ.addEventListener('change', apply); else BD_MQ.addListener(apply);
    apply();
    show(0);
  }

  function initBundle(el) {
    const json = $('[data-dzbd-json]', el);
    if (!json || el.dataset.ready) return;
    el.dataset.ready = '1';
    bundleSteps(el);
    const D = JSON.parse(json.textContent), T = D.texts, low = +el.dataset.low || 10;
    const idIn = $('[data-id]', el), dnote = $('[data-dnote]', el), form = $('.pd-form', el), done = $('[data-done]', el);
    const V = D.variants, v0 = V.find((v) => v.id === +idIn.value) || V.find((v) => v.av) || V[0];
    const ST = { c: v0.c, x: v0.x };
    const cur = () => V.find((v) => v.c === ST.c && v.x === ST.x);
    const COLS = uniq(V.map((v) => v.c)), OPTS = uniq(V.map((v) => v.x).filter(Boolean));
    const media = {};
    D.media.forEach((m) => (media[m.id] = m));
    const info = (x) => D.optInfo[x] || [x, ''];
    const lowQ = (v) => v.q != null && v.q > 0 && v.q <= low;
    const bikePart = D.parts.find((p) => p.bike);
    const partVar = (p, v) => p.vars.find((x) => x.label === (p.bike ? v.c : v.x)) || (v.x && p.vars.find((x) => x.label.indexOf(v.x) === 0)) || p.vars[0];
    const partName = (p, v) => p.name + (p.vars.length > 1 ? ' · ' + (p.bike ? v.c : info(v.x)[0]) : '');

    /* Wert wählen; ist die Kombination nicht lieferbar, die nächste lieferbare mit diesem Wert nehmen */
    function pick(f, val) {
      ST[f] = val;
      const v = cur();
      if (!v || !v.av) {
        const a = V.filter((x) => x[f] === val && x.av);
        const b = a.find((x) => x.c === ST.c) || a.find((x) => x.x === ST.x) || a[0];
        if (b) { ST.c = b.c; ST.x = b.x; }
        else if (!cur()) { const any = V.find((x) => x[f] === val); if (any) { ST.c = any.c; ST.x = any.x; } }
      }
      render();
    }

    /* Galerie: ruhiges Bild (Block „Ruhiges Bild“) statt Variantenbild, dann die weiteren Bilder der Farbe */
    function pics(v) {
      const first = v.calm || media[v.f];
      return [first].concat(v.g.map((id) => media[id])).filter(Boolean);
    }

    const set = (k, h) => $$('[data-out="' + k + '"]', el).forEach((e) => (e.innerHTML = h));
    let lastV = null;
    function render() {
      const v = cur();
      if (!v) return;
      $$('[data-colors]', el).forEach((box) => {
        box.innerHTML = COLS.map((c) => {
          const x = V.find((y) => y.c === c && y.x === ST.x) || V.find((y) => y.c === c), av = x && x.av;
          return `<button type="button" class="pd-color${av ? '' : ' out'}" data-color="${esc(c)}" aria-pressed="${c === ST.c}"><i style="background:${esc(D.hex[c] || '#CFCFCF')}"></i><b>${esc(c)}</b><small>${av ? (lowQ(x) ? 'nur noch ' + x.q : T.avail) : T.out}</small></button>`;
        }).join('');
      });
      $$('[data-opts]', el).forEach((box) => {
        const sw = OPTS.every((o) => D.hex[o]);
        box.className = (sw ? 'pd-colors' : 'pd-sizes') + ' bd-opts';
        box.innerHTML = OPTS.map((o) => {
          const x = V.find((y) => y.c === ST.c && y.x === o), av = x && x.av, i = info(o), sub = av ? i[1] || T.avail : T.out, on = o === ST.x;
          return sw ? `<button type="button" class="pd-color${av ? '' : ' out'}" data-opt="${esc(o)}" aria-pressed="${on}"><i style="background:${esc(D.hex[o])}"></i><span><b>${esc(i[0])}</b><small>${esc(sub)}</small></span></button>`
            : `<button type="button" class="pd-size${av ? '' : ' out'}" data-opt="${esc(o)}" aria-pressed="${on}"><b>${esc(i[0])}</b><small>${esc(sub)}</small></button>`;
        }).join('');
      });
      D.parts.forEach((p, i) => {
        const pv = partVar(p, v), nm = partName(p, v);
        $$('[data-part="' + i + '"]').forEach((row) => {
          const im = $('[data-part-img]', row);
          if (im && pv && pv.u) { im.src = pv.u.replace('width=600', 'width=' + (im.dataset.w || 200)); if (im.alt) im.alt = nm; }
          const n = $('[data-part-name]', row); if (n) n.textContent = nm;
          const s = $('[data-part-sub]', row); if (s && p.sub) s.textContent = p.sub;
          const b = $('[data-part-bullets]', row);
          if (b && p.bullets.length) { b.innerHTML = p.bullets.map((x) => '<li>' + esc(x) + '</li>').join(''); b.hidden = false; }
        });
      });
      const save = v.cmp - v.p, acc = bikePart ? v.cmp - bikePart.p : 0;
      set('price', eur(v.p));
      set('single', v.cmp > v.p ? eur(v.cmp) : '');
      set('save', save > 0 ? esc(T.save.replace('[betrag]', eur(save))) : '');
      set('pct', save > 0 && acc > 0 && T.pct ? esc(T.pct.replace('[prozent]', Math.round((save / acc) * 100))) : '');
      if (T.rate) set('rate', esc(T.rate.replace('[betrag]', eur(Math.floor(v.p / 12)))) + '<a class="dz-fn" href="#fussnoten" aria-label="Fußnote: Pflichtangaben zur Ratenzahlung">*</a>');
      let stock;
      if (v.av) {
        let t = v.d && !/^sofort versandbereit/i.test(v.d) ? v.d : T.ready;
        if (lowQ(v)) t = T.lowStock.replace('[anzahl]', v.q) + ' · ' + t;
        stock = `<i class="${v.ds === 'yellow' ? 'low' : 'ok'}"></i>${esc(t)}`;
      } else stock = `<i></i>${esc(T.soldout)}`;
      set('stock', stock);
      set('barlabel', esc(D.name + ' · ' + v.c + (v.x ? ' · ' + info(v.x)[0] : '')));
      $$('[data-bd-review]', el).forEach((ul) => {
        const d = ul.dataset, rows = [[d.lBundle, D.name, 0], [d.lColor, v.c, 1]];
        if (v.x && d.lOpt) rows.push([d.lOpt, info(v.x)[0], 1]);
        ul.innerHTML = rows.map(([k, val, go]) => `<li><span>${esc(k)}</span><b>${esc(val)}<button type="button" data-bgo="${go}">${esc(d.change)}</button></b></li>`).join('');
      });
      set('barprice', eur(v.p) + (v.cmp > v.p ? ' <s>' + eur(v.cmp) + '</s>' : ''));
      $$('[data-cta]', el).forEach((b) => (b.hidden = !v.av));
      $$('[data-out="rate"]', el).forEach((e) => (e.hidden = !v.av));
      if (lastV !== v.id) {
        lastV = v.id;
        $$('[data-notify]', el).forEach((f) => { const i = $('input', f); i.hidden = true; i.required = false; i.value = ''; });
        $$('[data-done]', el).forEach((d) => (d.hidden = true));
        idIn.value = v.id;
        const note = v.ov || v.dd ? 'Voraussichtliche Lieferung: ' + (v.ov || v.dd) : '';
        dnote.value = note;
        dnote.disabled = !note;
        if (location.search.includes('variant=') || v.id !== v0.id) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
        gallery(el, pics(v));
      }
      $$('[data-notify]', el).forEach((f) => (f.hidden = v.av));
      /* Andere Bundles in derselben Farbe verlinken */
      $$('[data-sw-url]').forEach((a) => {
        if (a.getAttribute('aria-current') === 'page') return;
        let vs = [];
        try { vs = JSON.parse(a.dataset.swVars || '[]'); } catch (e) {}
        const t = vs.find((x) => x.c === ST.c && x.av) || vs.find((x) => x.c === ST.c);
        a.href = a.dataset.swUrl + (t ? '?variant=' + t.id : '');
      });
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = cur();
      if (!v || !v.av) return;
      addToCart([{ id: v.id, quantity: 1, properties: dnote.disabled ? {} : { __delivery_note: dnote.value } }], $('[data-cta]', el), done, T, v.id);
    });
    $$('[data-notify]', el).forEach((f) => notifyForm(f, done, T, () => cur().id));

    /* Größenberatung mit dem Bike im Bundle und dem anderen Modell (gibt es nicht als Bundle → Bike-Seite) */
    const B = D.bike, dlg = $('#sg', el), vk = $('#vk', el);
    const bv = (m) => B.variants.filter((v) => v.o[0] === m);
    const sg = dlg && sizeGuide(dlg, {
      models: $$('[data-sg-model]', dlg).map((b) => b.dataset.sgModel), sizesOf: (m) => uniq(bv(m).map((v) => v.o[1])), ride: T.ride, altInseam: 78, out: 'Gerade ausverkauft',
      colorsAvail: (m, s) => (m === B.model ? uniq(V.filter((v) => v.av).map((v) => v.c)) : bv(m).filter((v) => v.o[1] === s && v.av).map((v) => v.o[2])),
      applyLabel: (one, nm, big) => (one ? T.applyOne : T.applyMany.replace('[modell]', nm).replace('[groesse]', big)),
      apply: (m, s) => {
        if (m === B.model || !B.url) return;
        const t = bv(m).find((v) => v.o[1] === s && v.av) || bv(m).find((v) => v.o[1] === s);
        location.href = B.url + (t ? '?variant=' + t.id : '');
      },
    });
    const ship = vk && shipping(vk, D.vk, T.carrierRest, () => T.vkText.replace('[bundle]', D.name));
    const openSg = () => sg && sg.open(B.model);
    outside(el, openSg);

    el.addEventListener('click', (e) => {
      const t = e.target;
      const c = t.closest('[data-color]'); if (c) { pick('c', c.dataset.color); return; }
      const o = t.closest('[data-opt]'); if (o) { pick('x', o.dataset.opt); return; }
      if (t.closest('[data-bar-cta]')) { e.preventDefault(); const b = $('[data-cta]:not([hidden])', el) || $('[data-notify]', el); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (t.closest('[data-sg-open]')) { openSg(); return; }
      if (ship && t.closest('[data-vk-open]')) ship.open();
    });

    /* Titel bleibt auf dem Desktop stehen (CSS sticky): Abstand zum Theme-Header, der beim Hochscrollen einfährt, und Höhe des Titels
       für die Galerie darunter */
    const head = $('[data-bd-head]', el), hdr = document.querySelector('.section-header');
    if (head) {
      let raf = 0, tm = 0;
      const place = () => {
        raf = 0;
        const top = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
        el.style.setProperty('--bd-top', top + 'px');
        el.style.setProperty('--bd-head', head.offsetHeight + 'px');
        head.classList.toggle('on', scrollY > 0 && head.getBoundingClientRect().top <= top + 1);
      };
      const queue = () => { if (!raf) raf = requestAnimationFrame(place); clearTimeout(tm); tm = setTimeout(place, 260); };
      addEventListener('scroll', queue, { passive: true });
      addEventListener('resize', queue);
      if ('ResizeObserver' in window) new ResizeObserver(queue).observe(head);
      if (hdr) {  /* der Header blendet sich per Klasse und Übergang ein/aus – danach neu messen */
        if ('MutationObserver' in window) new MutationObserver(queue).observe(hdr, { attributes: true, attributeFilter: ['class', 'style'] });
        hdr.addEventListener('transitionend', queue);
      }
      place();
    }
    render();
  }

  /* Aufbauvideo als Fenster: Links auf YouTube in PDP-Sections (.pd) öffnen ein <dialog> mit youtube-nocookie – erst nach dem Klick */
  function videoPop() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.pd a[href*="youtube.com/watch"], .pd a[href*="youtu.be/"]');
      if (!a || e.metaKey || e.ctrlKey || !window.HTMLDialogElement) return;
      const m = /(?:v=|youtu\.be\/)([\w-]{6,})/.exec(a.href); if (!m) return;
      e.preventDefault();
      let d = document.querySelector('dialog.pd-vid');
      if (!d) {
        d = document.createElement('dialog'); d.className = 'pd-vid'; d.setAttribute('aria-label', 'Video');
        d.innerHTML = '<button type="button" class="pd-vid__x" aria-label="Video schließen">×</button><div class="pd-vid__f"></div>'
          + '<p class="pd-vid__more"><a href="/pages/montage-und-anleitungen#aufbau">Alle Schritte auf „Montage & Anleitungen“</a><a data-yt-ext target="_blank" rel="noopener">Auf YouTube öffnen ↗\uFE0E</a></p>';
        document.body.appendChild(d);
        d.addEventListener('click', (ev) => { if (ev.target === d || ev.target.closest('.pd-vid__x')) d.close(); });
        d.addEventListener('close', () => { $('.pd-vid__f', d).innerHTML = ''; });
      }
      $('.pd-vid__f', d).innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(m[1]) + '?autoplay=1&rel=0&playsinline=1" title="' + esc(a.textContent.trim() || 'Video') + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      $('[data-yt-ext]', d).href = a.href;
      d.showModal();
      /* Ohne Zustimmung (Pandectes) bekommt das iframe kein src – dann Hinweis und Link zu YouTube statt schwarzer Fläche */
      setTimeout(() => {
        const f = $('.pd-vid__f iframe', d);
        if (f && !f.getAttribute('src')) $('.pd-vid__f', d).innerHTML = '<div class="pd-vid__off"><p>Zum Schutz deiner Daten laden wir YouTube erst, wenn du es in den Cookie-Einstellungen erlaubst.</p>'
          + '<a class="dz-btn" href="' + esc(a.href) + '" target="_blank" rel="noopener">Video auf YouTube ansehen ↗\uFE0E</a></div>';
      }, 150);
    });
  }

  function boot() {
    videoPop();
    groupsSet();
    compareTop();
    const or = document.querySelector('[data-one-range]'); if (or) ONE_RANGE = or.dataset.oneRange.replace(/\s*cm\s*$/i, '') + ' cm';
    $$('[data-dzp]').forEach(init); $$('[data-dzb]').forEach(initBware); $$('[data-dzbd]').forEach(initBundle);
  }
  tabs();
  specGroups();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
